/* eslint-disable react/no-multi-comp */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { DialogContentText, Grid } from '@material-ui/core';
import { DialogDefault,  Input, SearchSelect, DefaultSelect } from '../../../components';
import * as selectorsAuth from '../../../store/auth/reducer';
import * as actionsNsmp from '../../../store/nsmp/actions';
import Fuse from 'fuse.js';

const UsuMutuoServiceTab = ({ nsmps, open, onClose }) => {
  const [rows, setRows] = useState([]);
  const [filtroValues, setFiltroValues] = useState({});

  const fuse = new Fuse(rows, {
    keys: ['endereco'],
    threshold: 0.4,
    distance: 100, 
    ignoreLocation: true,
    includeScore: true,
    ignoreDiacritics: true,
    isCaseSensitive: false,
  });

  const filter = () => {
    let filteredRows = nsmps;

    if (Array.isArray(filtroValues.situacaoPostes)) {
      filteredRows = filteredRows.filter(p => {
        let situacaoPosteValue = p.situacaoPoste;
        if (!situacaoPosteValue) {
          situacaoPosteValue = "Vazio";
        }

        return filtroValues.situacaoPostes.includes(situacaoPosteValue);
      });
    }

    if (Array.isArray(filtroValues.statusDigitacao)) {
      filteredRows = filteredRows.filter(p => {
        const subNsmpStatus = p.subNsmpStatus;

        let statusDigitacaoRow = "1";
        if (p.digitadoEmValue) {
          statusDigitacaoRow = "3";
        } else if (subNsmpStatus && subNsmpStatus.total !== subNsmpStatus.aguardandoValidacao) {
          statusDigitacaoRow = "2";
        }

        return filtroValues.statusDigitacao.includes(statusDigitacaoRow)
      });
    }

    if (filtroValues.numeroPoste) {
      const termo = filtroValues.numeroPoste.toLowerCase();
      filteredRows = filteredRows.filter(p => p.numeroPoste && p.numeroPoste.toLowerCase().includes(termo));
    }

    if (filtroValues.endereco) {
      const fuzzyResults = fuse.search(filtroValues.endereco).map(r => r.item);
      const ids = new Set(fuzzyResults.map(p => p.id));
      filteredRows = filteredRows.filter(p => ids.has(p.id));
    }

    setRows(filteredRows);
  }

  return <DialogDefault
    open={open}
    handlerCancel={() => { 
      onClose(false); 
      // setFilterApplied(Object.keys(filtroValues ?? {}).length > 0); 
    }}
    handlerConfirm={() => {
      filter();
      onClose(false);
      // setFilterApplied(true);
    }}
    title="Filtros"
    confirmMessage="Filtrar"
    headerAction={[
      {
        onClick: () => {
          setRows(nsmps);
          setFiltroValues({});
          onClose(false);
          // setFilterApplied(false);
        },
        title: "Limpar",
      },
    ]}
  >
    <DialogContentText> 
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <SearchSelect
            label="Serviço"
            multiSelect
            onSelect={servico => setFiltroValues({ ...filtroValues, servico })}
            options={[
              {'value': 'analiseRisco', 'label': 'Análise de Risco'},
              {'value': 'fotoInicio', 'label': 'Foto Inicial'},
              {'value': 'servico', 'label': 'Serviço'},
              {'value': 'fotoFim', 'label': 'Foto Final'},
            ]}
            value={filtroValues.servico}
          />
        </Grid>
        <Grid item xs={12}>
          <SearchSelect
            label="Prioridade"
            multiSelect
            onSelect={prioridade => setFiltroValues({ ...filtroValues, prioridade })}
            options={[
              {id: 'E', nome: 'E'},
              {id: '1', nome: '1'},
              {id: '2', nome: '2'},
              {id: '3', nome: '3'},
              {id: '4', nome: '4'},
            ]}
            value={filtroValues.prioridade}
          />
        </Grid>
        <SearchSelect
          label="Tipo de Serviço"
          name="tipoServico"
          multiSelect
          options={[
            {id: 'E', nome: 'E-mail'},
            {id: 'EM', nome: 'Emergência'},
            {id: 'L', nome: 'Limpeza de Faixa'},
            {id: 'M', nome: 'Manutenção'},
            {id: 'NC', nome: 'Não Cadastrada'},
            {id: 'OB', nome: 'Objeto na Rede'},
            {id: 'OS', nome: 'OSAF'},
            {id: 'PL', nome: 'Planilha'},
            {id: 'P', nome: 'Poda RDR ou RDU'},
            {id: 'PR', nome: 'Programada'},
          ]}
          onSelect={event => setFiltroValues({ ...filtroValues, tipoServico: event.target.value }) }
          value={filtroValues.tipoServico}
        />
        <Grid>
          <Input
            name="nsmpProgramada"
            label="N° Nsmp Programada"
            onChange={event => setFiltroValues({...filtroValues, nsmpProgramada: event.target.value}) }
            value={filtroValues.nsmpProgramada}
          />
        </Grid>
        <Grid>
          <Input
            name="nsmpNova"
            label="N° Nsmp Nova"
            onChange={event => setFiltroValues({...filtroValues, nsmpNova: event.target.value}) }
            value={filtroValues.nsmpNova}
          />
        </Grid>
        <Grid item xs={12}>
          <SearchSelect
            label="Status da Digitação"
            multiSelect
            onSelect={statusDigitacao => setFiltroValues({ ...filtroValues, statusDigitacao })}
            options={[
              {'value': '1', 'label': 'Aguardando Digitação'},
              {'value': '3', 'label': 'Digitação Finalizada'},
            ]}
            value={filtroValues.statusDigitacao}
          />
        </Grid>
      </Grid>
    </DialogContentText>
  </DialogDefault>
};

const mapStateToProps = state => ({
  userRole: selectorsAuth.getRole(state),
  userId: selectorsAuth.getUserId(state),
  authData: selectorsAuth.getAuth(state)
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      ...actionsNsmp
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UsuMutuoServiceTab);
